module.exports = __webpack_public_path__ + "static/media/_MIC2358.thumbnail.4bfbc641.png";